import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class MagicWandTool extends BaseTool {
  public id: ToolType = 'wand';
  public name = 'Magic Wand Selection Tool';
  public cursor = 'crosshair';

  public onMouseDown(_e: MouseEvent, canvasX: number, canvasY: number): void {
    this.editor.executeMagicWand(canvasX, canvasY, true);
  }
}
